import { render, staticRenderFns } from "./InputProp.vue?vue&type=template&id=188340f5&"
import script from "./InputProp.vue?vue&type=script&lang=js&"
export * from "./InputProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports